import * as basicLightbox from "basiclightbox";
import {EventDispatcher} from "./event-dispatcher";

export function renderImagePopup(imageUrl) {
    const lightbox = basicLightbox.create(`
            <div class="image-lightbox">
                <i class="icon icon-close-light" style="position: absolute;top: -35px;right: 0px;pointer-events: none"></i>
                <img src="${imageUrl}" style="max-width: 900px; object-fit: contain; padding: 5px;width: 100%;">
            </div>
        `);
    lightbox.show()

    EventDispatcher.$on('key:esc', () => {
        lightbox.close();
    });
}
